export default __webpack_public_path__ + "static/media/vertex-aoi.3c882b53.svg";